import React from 'react';
import './fade.css';

function Fade({ children, bottom, left }) {
  const direction = bottom ? 'fade-in-up' : left ? 'fade-in-left' : 'fade-in';
  return <div className={direction}>{children}</div>;
}

export default Fade;
